import React, { useContext, useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { AuthConsumer, AuthContext } from '../components/providers/AuthProvider';
import ProfilePolicies from '../PermissionUtility/ProfilePolicies';

const PrivateRoute = ({ component, ...rest }) => {
  const authService = useContext(AuthContext);
  const [user, setUser] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const policyFetch = async () => {
    const policiesTemp = await ProfilePolicies();
    localStorage.setItem('user_permissions', JSON.stringify(policiesTemp));
    setIsLoading(false);
  };

  useEffect(() => {
    if (user !== false) {
    policyFetch();
    }
  }, [user]);

  useEffect(() => {
    async function setAuthenticatedUser() {
      let authenticatedUser = await authService.signinSilent();
      if (!authenticatedUser && localStorage.getItem('access_token') == null) {
        authService.signinRedirect();
        return;
      }
      if (!authenticatedUser) {
        authenticatedUser = {
          access_token: localStorage.getItem('access_token'),
          id_token: localStorage.getItem('id_token')
        };
      }
      setUser(authenticatedUser);
    }
    setAuthenticatedUser();
  }, [authService]);
  const renderFn = (Component) => () => {
    return (
      <AuthConsumer>
        {() => {
          const { isAuthenticated } = authService;

          if (!!Component && isAuthenticated() && !isLoading) {
            return Component;
          }
          return <ClipLoader label="Validating credentials" />;
        }}
      </AuthConsumer>
    );
  };
  return (
    <div className={`md:container md:mx-auto gap-6 primary-wrapper font-muli ${rest?.pinChange && 'pl-10'}`}>
      <Route {...rest} render={renderFn(component)} user={user} />
    </div>
  );
};
export default PrivateRoute;
